<template>
  <div class="count">
     {{minutes}}:{{seconds}}
  </div>
</template>

<script>
export default {
  name: 'Countdown',
  props: {
    time: String
  },
  data() {
    return {
      counter: this.time
    };
  },
  mounted() {
    window.setInterval(() => {
      if (--this.counter < 0) {
        this.onFinishTime();
      }
    }, 1000);
  },
  methods: {
    onFinishTime: function() {
      this.counter = this.time;
    },
    leftPad: function(value, digits) {
      const numLength = String(value).length;
      const numZeroes = digits - numLength;
      return '0'.repeat(Math.max(numZeroes, 0)) + value;
    }
  },
  computed: {
    minutes: function() {
      let minutes = Math.trunc(this.counter / 60);
      return this.leftPad(minutes, 2);
    },
    seconds: function() {
      let seconds = Math.trunc(this.counter % 60);
      return this.leftPad(seconds, 2);
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/Countdown.vue